<template>
  <div class="topic-item" @click="goSelect">
    <slot>
      <div class="slot">
        <img class="join" src="http://exerland-bbs.oss-cn-shanghai.aliyuncs.com/JOIN.svg"/>
        <div class="total">{{ showAct ?  preCount: presetCount}}</div>
        <div class="desc">人在参与</div>
      </div>
    </slot>
    <img v-lazy="`${imageURL}?x-oss-process=image/resize,m_fill,w_1280,h_720`" alt="">
    <div class="content">
      <span class="title">{{title}}</span>
      <span class="desc">{{subTitle}}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0
    },
    imageURL: {
      type: String,
      default: 'http://exerlalnd.oss-cn-shanghai.aliyuncs.com/exerland-m/forum.png'
    },
    title: {
      type: String,
      default: '这里是话题的主标题主标题主标题主标题'
    },
    subTitle: {
      type: String,
      default: '这里是话题的主标题主标题主标题主标题'
    },
    preCount: {
      type: Number,
      default: 12313
    },
    showAct: {
      type: Boolean,
      default: false
    },
    presetCount: {
      type: Number,
      default: 12313
    }

  },
  methods: {
    goSelect () {
      this.$router.push({
        path: `/exerland/checkedTopic/${this.id}`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.topic-item {
  width: calc(100% - 32px);
  background:rgba(255,255,255,1);
  box-shadow:0px 2px 12px 0px rgba(0,0,0,0.12);
  position: relative;
  margin: 16px 16px 0;
  .slot {
    position: absolute;
    top: 0;
    right: 13px;
    width:66px;
    height:90px;
    box-sizing: border-box;
    background:rgba(0,0,0,0.7);
    padding: 7px 9px 5px;
    .join {
      width:45px;
      height:38px;
    }
    .total {
      font-size:15px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(255,255,255,1);
      line-height:21px;
      text-align: center;
    }
    .desc {
      font-size:12px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(255,255,255,1);
      line-height:17px;
    }
  }
  img {
    width: 100%;
    height: 190px;
  }
  .content {
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    .title {
      font-size:17px;
      font-family:PingFangSC-Semibold,PingFang SC;
      font-weight:600;
      color:rgba(0,0,0,1);
      line-height:24px;
      display: block;
      margin-bottom: 4px;
    }
    .desc {
      font-size:13px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(136,136,136,1);
      line-height:18px;
    }
  }
}
</style>
